import * as React from "react";

import { Divider, Form } from "semantic-ui-react";

import { connect } from "react-redux";

import { ThunkDispatch } from "redux-thunk";

import { Action } from "redux";

import { FollowUpTaskModel } from "../model";
import { ImmunisationTypeTask, loadImmunisationTypeTasks } from "../../crud/immunisationTypeTask";
import { ApplicationState } from "../../applicationState";
import { getUserSortableName } from "../../crud/adminUser/model";
import { AdminUserListModelWithTeams, AppState as AdminUserListModelWithTeamsState } from "../../crud/adminUserWithTeams/model";
import { loadAdminUsersWithTeams as loadAdminUsersAction } from "../../crud/adminUserWithTeams";
import { adminUsersWithTeamsSelector } from "../../crud/adminUserWithTeams/selectors";
import { activeImmunisationTypesSelector } from "../../crud/immunisationType/selectors";
import { ImmunisationType } from "../../crud/immunisationType";

import { FollowUpTaskForm } from "./FollowUpTaskForm";

export interface FollowUpTask {
    task: FollowUpTaskModel;
    isValid: boolean;
    isHidden: boolean;
}

interface OwnProps {
    showErrors: boolean;
    immunisationTypes: string[];
    onChange: (tasks: { task: FollowUpTaskModel; isValid: boolean }[]) => void;
    tasks: { task: FollowUpTaskModel; isValid: boolean }[];
    restrictToTaskTypes?: string[];
    updateTasks?: FollowUpTask[];
    forceTasksUpdate?: boolean;
    onTasksUpdate?: (updated: boolean) => void;
    multiple?: boolean;
    hideAssignmentOption?: boolean;
    assignmentOptionRequired?: boolean;
    showImmunisationNameAndType?: boolean;
}

interface StateProps {
    immunisationTypeTasks: ImmunisationTypeTask[];
    adminUsersWithTeams?: AdminUserListModelWithTeams[];
    immunisationTypesList: ImmunisationType[];
}

interface DispatchProps {
    loadImmunisationTasks: (immunisationTypeId: string) => Promise<void>;
    loadAdminUsers: () => void;
}

class FollowUpTasksUnconnected extends React.Component<OwnProps & StateProps & DispatchProps, { tasks: { task: FollowUpTaskModel; isValid: boolean }[] }> {
    constructor(props: OwnProps & StateProps & DispatchProps) {
        super(props);
        this.addTask = this.addTask.bind(this);
        this.removeTask = this.removeTask.bind(this);
        this.state = { tasks: props.tasks };

        if (!this.props.hideAssignmentOption && !this.props.adminUsersWithTeams?.length) {
            this.props.loadAdminUsers();
        }
    }

    public componentDidMount() {
        this.props.immunisationTypes
            .filter(immunisationType => !this.props.immunisationTypeTasks.some(t => t.immunisationTypeId === immunisationType))
            .forEach(immunisationType => this.props.loadImmunisationTasks(immunisationType));
    }

    public componentDidUpdate(prevProps: Readonly<OwnProps & StateProps & DispatchProps>) {
        if ((this.props.updateTasks &&
            this.props.updateTasks?.length > 0 &&
            this.props.forceTasksUpdate) ||
            (prevProps?.updateTasks?.length > 0 && this.props.updateTasks?.length === 0)) {

            this.setTasks(this.props.updateTasks);
        }
        else if (prevProps.tasks !== this.props.tasks) {
            this.setState({ tasks: this.props.tasks });
        }
    }

    private setTasks(tasksToSet: FollowUpTask[]) {
        this.setState({
            tasks: tasksToSet
        }, () => this.onTasksUpdate());
    }

    private getAdminUserOptions() {
        if (!this.props.adminUsersWithTeams?.length) {
            return [];
        }

        const adminUsersWithTeams = [...this.props.adminUsersWithTeams.sort((a, b) => getUserSortableName(a).localeCompare(getUserSortableName(b)))];

        adminUsersWithTeams.splice(0, 0, { id: "Unassigned", emailAddress: "Unassigned" });

        return adminUsersWithTeams;
    }

    public render() {
        const immunisationTypeTasks = this.props.immunisationTypeTasks.filter(t => this.props.immunisationTypes.indexOf(t.immunisationTypeId) > -1);
        return (
            <>
                {this.state.tasks.map((t, i) =>
                    (<React.Fragment key={i}>
                        <FollowUpTaskForm
                            task={t.task}
                            save={() => null}
                            immunisationTypeTasks={immunisationTypeTasks}
                            showErrors={this.props.showErrors}
                            onChange={(task, isValid) => this.setState({
                                tasks: [
                                    ...this.state.tasks.slice(0, i),
                                    { task, isValid },
                                    ...this.state.tasks.slice(i + 1)
                                ]
                            }, () => this.props.onChange(this.state.tasks))}
                            restrictToTaskTypes={this.props.restrictToTaskTypes}
                            multiple={this.props.multiple ?? true}
                            hideAssignmentOption={this.props.hideAssignmentOption}
                            assignmentOptionRequired={this.props.assignmentOptionRequired}
                            adminUsers={this.getAdminUserOptions()}
                            immunisationTypes={this.props.immunisationTypesList}
                            showImmunisationNameAndType={this.props.showImmunisationNameAndType}
                        />
                        {this.state.tasks.length > 1 &&
                            <>
                                <Form.Button
                                    icon="remove"
                                    content="Remove Task"
                                    secondary
                                    onClick={() => this.removeTask(i)}
                                    type="button"
                                />
                                <Divider />
                            </>}
                    </React.Fragment>)
                )}
                <Form.Button
                    icon="add"
                    content="Add another Task"
                    secondary
                    onClick={this.addTask}
                    type="button"
                />
            </>
        );
    }

    public addTask() {
        this.setState({
            tasks: [...this.state.tasks, { task: { taskType: null, immunisationTypeTasks: [] }, isValid: false }]
        }, () => this.props.onChange(this.state.tasks));
    }

    public removeTask(i: number) {
        this.setState({
            tasks: [
                ...this.state.tasks.slice(0, i),
                ...this.state.tasks.slice(i + 1)
            ]
        }, () => this.props.onChange(this.state.tasks));
    }

    private onTasksUpdate() {
        if (this.props.onTasksUpdate) {
            this.props.onTasksUpdate(false);
        }
        this.props.onChange(this.state.tasks);
    }

}

const mapStateToProps = (state: ApplicationState & AdminUserListModelWithTeamsState): StateProps => {
    return {
        adminUsersWithTeams: adminUsersWithTeamsSelector(state),
        immunisationTypeTasks: state.immunisationTypeTasks,
        immunisationTypesList: activeImmunisationTypesSelector(state)
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, Action>): DispatchProps => ({
    loadImmunisationTasks: (immunisationTypeId: string) => dispatch(loadImmunisationTypeTasks({ immunisationTypeId })),
    loadAdminUsers: () => dispatch(loadAdminUsersAction()),
});

export const FollowUpTasks = connect(mapStateToProps, mapDispatchToProps)(FollowUpTasksUnconnected);
